import { jsx as l } from "react/jsx-runtime";
const m = ({ children: a }) => /* @__PURE__ */ l("div", { className: "w-full max-w-xl", children: a });
export {
  m as default
};
